import { CoachConsultationActionTypes } from "../constants/actionTypes"
import { ICoachTasks } from "../interfaces/coachTasks/ICoachTasks"
import { ICoachConsultation } from "../interfaces/ongoingConsultation/ICoachConsultationData"
import { findIndex } from "lodash"

function init(): ICoachConsultation {
	return {} as ICoachConsultation
}
export const coachConsultationReducer = function (state = init(), action: any) {
	switch (action.type) {
		case CoachConsultationActionTypes.SET_TAB_CONFIG:
			return { ...state, tabConfig: action.payload }

		case CoachConsultationActionTypes.UPDATE_OPENED_TAB:
			return { ...state, openedTab: action.payload }

		case CoachConsultationActionTypes.MARK_DATA_FETCHED: {
			const tabConfig = [...state.tabConfig]
			const openedTab = { ...state.openedTab, dataFetched: true }
			const openedTabIdx = findIndex(tabConfig, (tab) => tab.widget === openedTab.widget)
			tabConfig[openedTabIdx] = openedTab
			return { ...state, openedTab, tabConfig }
		}
		case CoachConsultationActionTypes.MARK_UNSAVED_CHANGES: {
			const tabConfig = [...state.tabConfig]
			const openedTab = { ...state.openedTab, unsavedChanges: true }
			const openedTabIdx = findIndex(tabConfig, (tab) => tab.widget === openedTab.widget)
			tabConfig[openedTabIdx] = openedTab
			return { ...state, openedTab, tabConfig }
		}

		case CoachConsultationActionTypes.FETCH_COACH_ONGOING_CONSULT_DETAILS_SUCCESS:
			return {
				...state,
				consultationData: {
					...(state?.consultationData || {}),
					...action.consultData,
				},
			}
		case CoachConsultationActionTypes.SAVE_CONSULT_SECTION_RECOMMENDATIONS:
			return { ...state, suggestions: action.payload }

		case CoachConsultationActionTypes.UPDATE_WIDGETS_DATA: {
			const prevWidgetsData = { ...(state.updatedWidgetData || {}) }
			return { ...state, updatedWidgetData: { ...prevWidgetsData, ...action.widgetsData } }
		}
		case CoachConsultationActionTypes.SAVE_MEDICAL_PROFILE:
		case CoachConsultationActionTypes.UPDATE_EDITED_MEDICAL_PROFILE:
			return { ...state, medicalProfile: action.medicalProfile }

		case CoachConsultationActionTypes.SAVE_PATIENT_PERSONAL_PROFILE:
		case CoachConsultationActionTypes.UPDATE_EDITED_PATIENT_PERSONAL_PROFILE:
			return { ...state, patientPersonalProfile: action.patientPersonalProfile }

		case CoachConsultationActionTypes.SAVE_USER_ATTRIBUTES:
		case CoachConsultationActionTypes.UPDATE_EDITED_USER_ATTRIBUTE:
			return { ...state, userAttributes: action.userAttributes }

		case CoachConsultationActionTypes.SAVE_PATIENT_DIET_PLAN:
		case CoachConsultationActionTypes.UPDATE_PATIENT_DIET_PLAN: {
			const patientPlan = { ...(state.patientPlan || {}) }
			return { ...state, patientPlan: { ...patientPlan, dietPlan: action.dietPlan } }
		}

		case CoachConsultationActionTypes.SAVE_PATIENT_INTERVENTION: {
			const patientPlan = { ...(state.patientPlan || {}) }
			return { ...state, patientPlan: { ...patientPlan, intervention: action.intervention } }
		}

		case CoachConsultationActionTypes.SAVE_PATIENT_GOALS: {
			const patientPlan = { ...(state.patientPlan || {}) }
			return { ...state, patientPlan: { ...patientPlan, goals: action.goals } }
		}

		case CoachConsultationActionTypes.UPDATE_PATIENT_GOALS: {
			const patientPlan = { ...(state.patientPlan || {}) }
			return { ...state, patientPlan: { ...patientPlan, goals: action.payload?.goals, patientGoalMetrics: action.payload?.patientGoalMetrics } }
		}

		case CoachConsultationActionTypes.UPDATE_DELETED_GOAL_IDS: {
			const patientPlan: any = { ...(state.patientPlan || {}) }
			return { ...state, patientPlan: { ...patientPlan, patientGoalDeleteIds: [...(patientPlan.patientGoalDeleteIds || []), ...action.patientGoalDeleteIds] } }
		}

		case CoachConsultationActionTypes.DELETE_PATIENT_PLAN: {
			return { ...state, patientPlan: {} }
		}

		case CoachConsultationActionTypes.UPDATE_WIDGETS_ERROR: {
			return { ...state, widgetErrors: { ...(state.widgetErrors || {}), ...action.widgetErrors } }
		}

		case CoachConsultationActionTypes.UPDATE_WIDGETS_MANDATORY_STATUS: {
			return { ...state, mandatoryStatus: { ...(state.mandatoryStatus || {}), ...action.mandatoryStatus } }
		}

		case CoachConsultationActionTypes.RESET_COACH_CONSULT_STATE: {
			return {}
		}

		case CoachConsultationActionTypes.SAVE_CONSULT_DATA_FROM_REDIS: {
			return {
				...state,
				...(action.consultationData || {}),
			}
		}

		case CoachConsultationActionTypes.UPDATED_SECTION_CARD_COLLAPSE_STATUS: {
			return {
				...state,
				sectionCardCollapseStatus: { ...(state?.sectionCardCollapseStatus || {}), ...(action.payload || {}) },
			}
		}
		case CoachConsultationActionTypes.UPDATE_ACTIVE_DIET_PLAN_REMINDER_THEMES:
			return {
				...state,
				activeDietPlanReminderThemes: action.payload,
			}
		case CoachConsultationActionTypes.FETCH_PAST_PRESCRIPTIONS:
			return {
				...state,
				pastPrescriptions: action.pastPrescriptions,
			}
		case CoachConsultationActionTypes.UPDATE_STICKY_NOTE_TEXT:
			return {
				...state,
				stickyNoteText: action.note,
			}
		case CoachConsultationActionTypes.UPDATE_THINGS_TO_BUY:
			return {
				...state,
				thingsToBuy: action.thingsToBuy,
			}
		case CoachConsultationActionTypes.UPDATE_PENDING_LOG_MARKERS:
			return {
				...state,
				pendingLogMarkers: action.pendingLogMarkers,
			}
		case CoachConsultationActionTypes.UPDATE_PENDING_TASK_PROFILES:
			return {
				...state,
				coachTasks: {
					...state.coachTasks,
					pendingTaskProfiles: action.pendingTaskProfiles,
				} as ICoachTasks,
			}
		case CoachConsultationActionTypes.UPDATE_CURRENT_ACTIVE_PATIENT_GOALS_FOR_TASK_SCRIPTING:
			return {
				...state,
				coachTasks: {
					...state.coachTasks,
					currentActivePatientGoals: action.currentActivePatientGoals,
				} as ICoachTasks,
			}
		case CoachConsultationActionTypes.UPDATE_CURRENT_ACTIVE_PATIENT_INTERVENTIONS_FOR_TASK_SCRIPTING:
			return {
				...state,
				coachTasks: {
					...state.coachTasks,
					currentActivePatientInterventions: action.currentActivePatientInterventions,
				} as ICoachTasks,
			}
		case CoachConsultationActionTypes.UPDATE_TASK_PROFILE_COMPLETION_STATUS:
			return {
				...state,
				coachTasks: {
					...state.coachTasks,
					taskProfileCompletionStatus: action.taskProfileCompletionStatus,
				} as ICoachTasks,
			}
		
		case CoachConsultationActionTypes.UPDATE_COACH_CONSULTATION_STATUS:
			return {
				...state,
				consultationData: {
					...state.consultationData,
					appointmentSchedule: {
						...state.consultationData?.appointmentSchedule,
						status: action.payload
					}
				}
			}
		case CoachConsultationActionTypes.UPDATE_CURRENT_ASSIGNED_EXPERIMENTS:
			return {
				...state,
				experiments: {
					...state.experiments,
					currentAssignedExperiments: action.payload,
				}
			}
		case CoachConsultationActionTypes.UPDATE_NEW_ADDED_EXPERIMENTS:
			return {
				...state,
				experiments: {
					...state.experiments,
					newAddedExperiments: action.payload,
				}
			}
		case CoachConsultationActionTypes.UPDATE_ALL_EXPERIMENT_LEVELS:
			return {
				...state,
				experiments: {
					...state.experiments,
					allExperimentLevels: action.payload,
				}
			}
		case CoachConsultationActionTypes.UPADTE_AI_FITNESS_PLAN:
			return {
				...state,
				aiFitnessPlan: action.payload
			}
		default:
			return state
	}
}
